// extracted by mini-css-extract-plugin
export default {"onlyDark":"Education_onlyDark__SOg-T","onlyLight":"Education_onlyLight__Uncb6","education":"Education_education__MI2wW"};